<template>
  <ClientOnly>
    <div
      v-if="showCookieBanner"
      id="cookieConsentContainer"
      class="cookieConsentContainer"
      :class="{ show: show }"
    >
      <div class="cookieConsent">
        <div class="cookieConsentContent">
          <div class="content">
            <div class="desc">
              <template
                v-for="item in siteStore.getListAs<CookieBannerModel>(
                  cfg.elements.cookieBanner.value
                )"
                :key="item?.system?.id"
              >
                <RichText :value="item.elements.content.value" />
              </template>
            </div>
          </div>

          <div class="controls">
            <a href="#" class="acceptCookieButton" @click="onCookieAccept()">Accept</a>
            <a href="#" class="close" @click="onCookieAccept()" aria-label="Close">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.2806 14.2194C15.3502 14.2891 15.4055 14.3718 15.4432 14.4629C15.4809 14.5539 15.5003 14.6515 15.5003 14.7501C15.5003 14.8486 15.4809 14.9462 15.4432 15.0372C15.4055 15.1283 15.3502 15.211 15.2806 15.2807C15.2109 15.3504 15.1281 15.4056 15.0371 15.4433C14.9461 15.4811 14.8485 15.5005 14.7499 15.5005C14.6514 15.5005 14.5538 15.4811 14.4628 15.4433C14.3717 15.4056 14.289 15.3504 14.2193 15.2807L7.99993 9.06036L1.78055 15.2807C1.63982 15.4214 1.44895 15.5005 1.24993 15.5005C1.05091 15.5005 0.860034 15.4214 0.719304 15.2807C0.578573 15.1399 0.499512 14.9491 0.499512 14.7501C0.499512 14.551 0.578573 14.3602 0.719304 14.2194L6.93962 8.00005L0.719304 1.78068C0.578573 1.63995 0.499512 1.44907 0.499512 1.25005C0.499512 1.05103 0.578573 0.860156 0.719304 0.719426C0.860034 0.578695 1.05091 0.499634 1.24993 0.499634C1.44895 0.499634 1.63982 0.578695 1.78055 0.719426L7.99993 6.93974L14.2193 0.719426C14.36 0.578695 14.5509 0.499634 14.7499 0.499634C14.949 0.499634 15.1398 0.578695 15.2806 0.719426C15.4213 0.860156 15.5003 1.05103 15.5003 1.25005C15.5003 1.44907 15.4213 1.63995 15.2806 1.78068L9.06024 8.00005L15.2806 14.2194Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </ClientOnly>
</template>
<script lang="ts" setup>
import type { CookieBannerModel } from '~/models'
const siteStore = useSiteStore()
const cfg = siteStore.siteConfig
const config = useRuntimeConfig()
const cookieName = 'jndCookieBannerSeen'
const show = ref(false)
const cookie = useCookie(cookieName, {
  secure: true
})

const showCookieBanner = computed(() => {
  if (config.public.enableSmartLinks) return false
  return siteStore.siteConfig.elements.cookieBanner.value.length > 0
})

onMounted(() => {
  if (showCookieBanner.value && !cookie.value) {
    show.value = true
  } else {
    show.value = false
  }
})

function onCookieAccept() {
  cookie.value = 'true'
  show.value = false
}
</script>
